import { Theme } from '@material-ui/core/styles';

export const getMuiAutocomplete = (theme: Theme): Record<string, unknown> => ({
  MuiAutocomplete: {
    root: {
      borderBottom: `1px solid ${theme.palette.grey[400]}`,

      [theme.breakpoints.up('md')]: {
        border: 'none',
      },
    },

    endAdornment: {
      right: theme.spacing(1.5),

      '& button:hover': {
        backgroundColor: 'transparent',
      },
      '& svg': {
        fill: theme.palette.common.black,
        fontSize: theme.typography.pxToRem(24),
      },

      [theme.breakpoints.only('sm')]: {
        right: theme.spacing(2.5),
      },
    },

    inputRoot: {
      '&[class*="MuiInput-root"]': {
        padding: theme.spacing(1.125, 4, 1.125, 1.25),
        paddingBottom: theme.spacing(1.125),

        '&:focus': {
          border: 'none',
        },
        '&:active': {
          border: 'none',
        },
        '&.MuiInputBase-adornedEnd': {
          paddingRight: theme.spacing(4),

          [theme.breakpoints.up('md')]: {
            paddingRight: 0,
          },
        },
        '&.MuiInputBase-adornedStart': {
          paddingLeft: theme.spacing(1.25),

          [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(2.25),
          },
          [theme.breakpoints.up('md')]: {
            paddingLeft: 0,
          },
        },

        [theme.breakpoints.up('md')]: {
          padding: 0,

          '& .MuiAutocomplete-input': {
            border: `1px solid ${theme.palette.grey[400]}`,
            padding: theme.spacing(1.75, 1.25),

            '&:focus': {
              border: `1px solid ${theme.palette.common.black}`,
            },
          },
        },
      },

      '&.MuiInput-root input': {
        border: 'none',

        '&:focus': {
          border: 'none',
        },
      },

      [theme.breakpoints.up('md')]: {
        '& .MuiIconButton-root': {
          display: 'none',
        },
      },
    },

    listbox: {
      maxHeight: '60vh',
      padding: 0,
    },

    paper: {
      boxSizing: 'border-box',
      padding: theme.spacing(1, 2, 0),
      margin: 0,
      marginTop: '1px',

      '& li': {
        borderBottom: `1px solid ${theme.palette.grey[400]}`,
        padding: theme.spacing(2, 0),

        '&:hover': {
          backgroundColor: theme.palette.grey[200],
        },
      },

      '& .customAddressRequired': {
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-between',
        padding: theme.spacing(0.5, 0),
        width: '100%',
      },

      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 3),
      },

      [theme.breakpoints.up('md')]: {
        border: `1px solid ${theme.palette.grey[400]}`,
        marginTop: 0,
        padding: 0,

        '&:empty': {
          borderColor: 'transparent',
        },

        '& li': {
          borderBottom: 'none',

          '& .MuiTypography-root': {
            padding: theme.spacing(0, 2),
          },
        },

        '& .customAddressRequired': {
          borderTop: `1px solid ${theme.palette.grey[400]}`,
          marginTop: theme.spacing(-2),
          padding: theme.spacing(2, 1.25, 0, 0),
        },
      },
    },

    popper: {
      marginLeft: '5px',

      [theme.breakpoints.up('md')]: {
        boxShadow: `0 6px 12px 0px ${theme.palette.grey[200]}`,
        boxSizing: 'border-box',
        marginLeft: 0,
      },
    },
  },
});
